import { createSelector } from 'reselect'

const select = (state) => state.faq

const selectFaq = createSelector(select, (faq) => faq.faq)

const selectFaqFetching = createSelector(select, (faq) => faq.isFetching)

export { selectFaq, selectFaqFetching }
